import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, MessageCircle, X, Sparkles } from "lucide-react";
import { BRAND } from "@/lib/site";

export default function StickyCTA() {
  const [open, setOpen] = useState(false);
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 240);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!show) return null;

  return (
    <div data-testid="sticky-cta" className="fixed bottom-5 right-5 z-50 flex flex-col items-end gap-3">
      {open && (
        <div className="flex flex-col gap-2 animate-fade-up">
          <Link
            data-testid="sticky-apply-guided"
            to="/apply-whatsapp"
            onClick={() => setOpen(false)}
            className="flex items-center gap-2 rounded-full bg-brand-gold px-4 py-2.5 text-sm font-semibold text-brand-forest shadow-xl hover:bg-[#d0972f] transition-colors"
          >
            <Sparkles className="h-4 w-4" /> Apply on WhatsApp
          </Link>
          <a
            data-testid="sticky-call"
            href={`tel:${BRAND.phoneE164}`}
            className="group flex items-center gap-2 rounded-full bg-brand-forest px-4 py-2.5 text-sm font-semibold text-brand-cream shadow-xl hover:bg-brand-terracotta transition-colors"
          >
            <Phone className="h-4 w-4" /> Call {BRAND.phone}
          </a>
          <a
            data-testid="sticky-whatsapp"
            href={`https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(
              "Hi Raj, I'd like to discuss a loan."
            )}`}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-2.5 text-sm font-semibold text-white shadow-xl hover:bg-[#1ea854] transition-colors"
          >
            <MessageCircle className="h-4 w-4" /> Quick chat
          </a>
        </div>
      )}
      <button
        data-testid="sticky-toggle"
        aria-label="Toggle quick contact"
        onClick={() => setOpen(!open)}
        className={`grid h-14 w-14 place-items-center rounded-full bg-brand-terracotta text-white shadow-[0_18px_36px_-12px_rgba(200,98,65,0.65)] transition-all hover:bg-[#b25535] ${
          open ? "" : "animate-pulse-soft"
        }`}
      >
        {open ? <X className="h-5 w-5" /> : <MessageCircle className="h-6 w-6" />}
      </button>
    </div>
  );
}
